module.exports = __webpack_public_path__ + "img/email-icon.aa47802b.svg";